import { Category, NavigationItem } from './';

export class NavigationRoot extends NavigationItem {
  public static fromCategory(category: Category): NavigationRoot {
    const childItems = category.children
      ? category.children.map(NavigationItem.fromCategory)
      : undefined;

    return new NavigationRoot(category.name, category.route, childItems);
  }

  constructor(
    name: string,
    url: string,
    public children: Array<NavigationItem> = [],
    // Overrides `name` with out overflow icon, and hides the parent
    // link in mobile menu
    public isOverflowItem: boolean = false,
    public onClick?: React.MouseEventHandler<HTMLAnchorElement>
  ) {
    super(name, url, undefined, onClick);

    this.children.forEach(child => (child.parent = this));
  }
}



// WEBPACK FOOTER //
// ./src/app/models/NavigationRoot.ts